import { render, staticRenderFns } from "./DenyVoteDialog.vue?vue&type=template&id=5a02346c&scoped=true&"
import script from "./DenyVoteDialog.vue?vue&type=script&lang=js&"
export * from "./DenyVoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./DenyVoteDialog.vue?vue&type=style&index=0&id=5a02346c&lang=scss&scoped=true&"
import style1 from "./DenyVoteDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02346c",
  null
  
)

export default component.exports